import React, { useEffect, useState } from 'react';

// Komponent tooltip z informacjami o technologiach i materiałach
const Tooltip = ({ title, description, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Opóźnienie pokazania tooltip
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    return (
        <div className="tooltip" onMouseLeave={onClose}>
        <div className="tooltip-title">
        {title}
        </div>
        <div className="tooltip-description">
        {description}
        </div>
        </div>
    );
};

export default Tooltip;
